import React from 'react';
import { Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { isMobile } from 'react-device-detect';

interface Props {
  isDisabled: boolean;
  value: string;
  callback: (value: string) => void;
}

function RadioButtons(props: Props): JSX.Element {
  return (
    <RadioGroup onChange={props.callback} value={props.value}>
      <Stack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 2 : 4} align="center">
        <Radio value="1" isDisabled={props.isDisabled}>
          {isMobile ? 'N° socio' : 'Número de socio'}
        </Radio>
        <Radio value="2" isDisabled={props.isDisabled}>
          {isMobile ? 'N° documento' : 'Número de documento'}
        </Radio>
        <Radio value="3" isDisabled={props.isDisabled}>
          {isMobile ? 'Nombre' : 'Nombre y/o apellido'}
        </Radio>
      </Stack>
    </RadioGroup>
  );
}

export default RadioButtons;
